import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  rateShopperGroupName: {
    description: 'Text displayed for the Rate Shopper group in CSW Service',
    defaultMessage: '<l>Rate Shopper</l>',
    id: 'vJUE2S',
  },
  helpLinkText: {
    description: 'Text displayed for the Rate Shopper group help link in CSW Service',
    defaultMessage: 'Learn more',
    id: 'GyV2Du',
  },
  upgradeToPremiumRateShopperButton: {
    description: 'text for a button that encourages the user to upgrade their plan',
    defaultMessage: 'Upgrade',
    id: 'BtUhBh',
  },
  manageRateShopperButton: {
    description: 'text for a button that navigates the user to the configuration page so they can manage their settings',
    defaultMessage: 'Manage',
    id: 'rWXai+',
  },
  rateShopperSummary: {
    description:
      'text that describes a "Rate Shoppers" feature. Users are provided with default options for free and can upgrade to customize their options',
    defaultMessage:
      'Rate Shoppers automatically select the best rate. Use defaults full of the most popular ShipStation services, or upgrade to customize your own.',
    id: 'crSaOm',
  },
});
